import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import CripNotice from 'crip-vue-notice';
import VueModal from '@kouts/vue-modal';

Vue.use(CripNotice);
Vue.component('Modal', VueModal);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
